class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
  
    if (variantId) {
      const variantData = this.getVariantData();
      const match = variantData.find(v => v.id == variantId);
  
      if (match) {
        this.currentVariant = match;
  
        // Wait for media slider + images to load
        this.waitForMediaReady().then(() => {
          this.updateMedia();
        });
      }
    }
  }

  waitForMediaReady() {
    return new Promise((resolve) => {
      const checkReady = () => {
        const swiperEl = document.querySelector('.flex.main-product-media.swiper.js-media-slider');
        const slidesReady = swiperEl?.querySelectorAll('swiper-slide img')?.length > 0;
        const swiperInitialized = swiperEl?.swiper;
  
        if (swiperEl && swiperInitialized && slidesReady) {
          resolve();
        } else {
          requestAnimationFrame(checkReady);
        }
      };
  
      checkReady();
    });
  }  

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.updateReviewWidget()
      this.renderProductInfo()
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    const variantData = this.getVariantData();
  
    this.currentVariant = variantData.find((variant) => {
      // Ensure we're correctly matching the selected options against the variant's options
      return this.options.every((selectedOption, index) => {
        return variant.options[index] === selectedOption;
      });
    });
  }
  
  updateReviewWidget() {
    if (!this.currentVariant) return;
  
    const productId = this.currentVariant.product_id;
  
    if (!productId) {
      console.warn('No product ID found for variant:', this.currentVariant.id);
      return;
    }
  
    // --- Update Reviews Section (Replace the Element)
    const oldReviewDiv = document.querySelector('[data-bv-show="reviews"]');
    if (oldReviewDiv) {
      const newReviewDiv = document.createElement('div');
      newReviewDiv.className = 'bv-reviews';
      newReviewDiv.setAttribute('data-bv-show', 'reviews');
      newReviewDiv.setAttribute('data-bv-product-id', productId);
  
      oldReviewDiv.replaceWith(newReviewDiv);
  
      this.updateBVWidget('[data-bv-show="reviews"]', productId, 'show_reviews');
    }
  
    // --- Update Rating Summary (Just Update Data Attribute)
    this.updateBVWidget('[data-bv-show="rating_summary"]', productId, 'show_rating_summary');
  }
  
  updateBVWidget(selector, productId, showType) {
    const element = document.querySelector(selector);
    if (!element) return;
  
    element.setAttribute('data-bv-productid', productId);
  
    if (window.BV && typeof BV.ui === 'function') {
      const options = {
        productId: productId,
        containerPrefix: ''
      };
  
      if (showType === 'show_reviews') {
        options.contentContainerDiv = element;
      }
  
      BV.ui('rr', showType, options);
    } else {
      console.warn(`BV UI not available for ${showType}`);
    }
  }
  

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.sku) return;

    const skuToFind = this.currentVariant.sku;
    const swiperEl = document.querySelector('.flex.main-product-media.swiper.js-media-slider');

    if (!swiperEl || !swiperEl.swiper) {
        console.warn("Swiper instance not found for .flex.main-product-media.swiper.js-media-slider!");
        return;
    }

    // Get all slides inside the correct swiper container
    const slides = Array.from(swiperEl.querySelectorAll('swiper-slide'));

    if (!slides.length) {
        console.warn("No slides found in the correct Swiper container!");
        return;
    }

    // Find the slide with an image whose alt matches the SKU
    let targetIndex = -1;
    slides.forEach((slide, index) => {
        const img = slide.querySelector('img');
        if (img) {
            if (img.getAttribute('alt')?.includes(skuToFind)) {
                targetIndex = index;
            }
        } else {
            console.warn(`Slide ${index} has no image!`);
        }
    });

    if (targetIndex === -1) {
        console.warn(`No matching slide found for SKU: ${skuToFind}`);
        return;
    }
    // Navigate to the correct slide

    swiperEl.swiper.slideTo(targetIndex);
}


  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )

    const locationChangeEvent = document.createEvent('Event');
    locationChangeEvent.initEvent('locationchange', true, true);
    window.dispatchEvent(locationChangeEvent);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    const skuElement = document.querySelector('.product-sku p.utility');
    if (skuElement) {
      skuElement.innerHTML = `<strong>SKU: </strong>${this.currentVariant.sku || 'N/A'}`;
    }
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        this.replaceInnerElement(html, `#price-${this.dataset.section}`)
        this.replaceInnerElement(html, `.js-bis-variant-fields`)

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  replaceInnerElement(html, selector) {
    const destination = document.querySelector(selector)
    const source = html.querySelector(selector)

    if (source && destination) destination.innerHTML = source.innerHTML
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"][data-native-pre-order-btn]')
    const buttonWrapper = addButton?.closest('.js-buttons-wrapper')
    const hasBIS = buttonWrapper?.classList?.contains('has-bis-form')

    if (!addButton) return

    if (disable) {
      if (hasBIS) buttonWrapper.classList.add('show-bis-form')

      addButton.setAttribute('disabled', true)
      if (text) addButton.textContent = text
    } else {
      if (hasBIS) buttonWrapper.classList.remove('show-bis-form')

      addButton.removeAttribute('disabled')
      addButton.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
